import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { Breadcrumb, Steps } from '@roo/roo';
import { IServerResponse } from '@/utils/request';
import Panel from './components/Panel/index';
import { getAccountDetails } from './api/api';
import { AccountDetail, WithdrawFlowStatusType } from './api/define';
import './index.scss';

// 路由参数
interface IMatchParams {
    outId: string;
}

interface WithdrawFlowsType {
    skey: number;
    desc: string;
    withdrawStatus: number;
}

function AccountDetails(props: RouteComponentProps<IMatchParams>) {
    const [accoutnInfo, setAccoutnInfo] = useState<AccountDetail>({
        moneyStr: '',
        bankAccountName: '',
        bankName: '',
        cardNumber: '',
        ctime: '',
        flowNo: 0,
        comment: '',
    });

    const [withdrawFlows, setWithdrawFlows] = useState<Array<WithdrawFlowsType>>([]);
    const [active, setActive] = useState<number>(0); // 当前进度
    const [status, setStatus] = useState<'error' | 'wait'>('wait'); // 当前状态

    const breadcrumbItems = [
        {
            text: '我的账户',
            icon: 'home',
            onClick: () => {
                props.history.replace({
                    pathname: '/settlementTP/balance',
                });
            },
        },
        {
            text: '账户余额提现详情',
        },
    ];

    useEffect(() => {
        function fetchAccountDetails() {
            const { outId } = props.match.params;
            getAccountDetails({ outId }).then(({ data }: IServerResponse<Array<AccountDetail>>) => {
                const {
                    moneyStr,
                    bankAccountName,
                    bankName,
                    cardNumber,
                    ctime,
                    flowNo,
                    comment,
                    withdrawFlowStatusList = [],
                } = data[0];
                setAccoutnInfo({
                    moneyStr,
                    bankAccountName,
                    bankName,
                    cardNumber,
                    ctime,
                    flowNo,
                    comment,
                });
                const list = withdrawFlowStatusList.map(
                    (item: WithdrawFlowStatusType, ind: number) => ({
                        skey: ind + 1,
                        title: item.displayMsg,
                        desc: item.withdrawTime,
                        withdrawStatus: item.withdrawStatus,
                    }),
                );
                setWithdrawFlows(list);
            });
        }
        fetchAccountDetails();
    }, []);

    useEffect(() => {
        if (withdrawFlows.length) {
            const ind = withdrawFlows.length - 1;
            const { withdrawStatus } = withdrawFlows[ind];
            if (withdrawStatus === 0) {
                setActive(1);
            } else if (withdrawStatus === 1 || withdrawStatus === -1) {
                setActive(2);
            } else if (withdrawStatus === 2) {
                setActive(3);
            } else if (withdrawStatus === 3) {
                setActive(3);
                setStatus('error');
            }
        }
    }, [withdrawFlows]);

    return (
        <div className="account-details">
            <Breadcrumb items={breadcrumbItems} />
            <Panel title="余额提现详情">
                <div className="account-info">
                    <div className="info-item">
                        <span>收入金额</span>
                        <span>{accoutnInfo.moneyStr}</span>
                    </div>
                    <div className="info-item">
                        <span>汇入账户</span>
                        <span>
                            {accoutnInfo.bankAccountName}
                            {'\u00A0\u00A0'}
                            {accoutnInfo.bankName}
                            {'\u00A0\u00A0'}
                            {accoutnInfo.cardNumber}
                        </span>
                    </div>
                    <div className="info-item">
                        <span>创建时间</span>
                        <span>{accoutnInfo.ctime}</span>
                    </div>
                    <div className="info-item">
                        <span>流水单号</span>
                        <span>
                            {Number(accoutnInfo.flowNo) === 0 ? '暂无' : accoutnInfo.flowNo}
                        </span>
                    </div>
                    <div className="info-item">
                        <span>备注</span>
                        <span>{accoutnInfo.comment}</span>
                    </div>
                </div>
            </Panel>
            <div style={{ height: '16px' }} />
            <Panel title="余额提现进度">
                <div className="account-schedule">
                    {withdrawFlows.length > 0 && (
                        <Steps status={status} steps={withdrawFlows} active={active} />
                    )}
                </div>
            </Panel>
        </div>
    );
}

export default AccountDetails;
